<template>
    <div>
        <div class="mb-3">
            <BackButton :href="$route('agencies')" :to="__('agency.agencies')"/>
        </div>

        <div class="card card-body">
            <div class="form-group">
                <label>{{ __('agency.parent') }}</label>
                <input class="form-control" type="text" :value="$page.props.agency.name" disabled>
            </div>

            <div class="form-group">
                <label>{{ __('agency.name') }}</label>
                <input class="form-control"
                       type="text"
                       :placeholder="__('agency.name')"
                       v-model="formData.agency_name"
                >
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ __('agency.payment_provider') }}</label>
                        <select class="form-control" v-model="formData.payment_provider_id">
                            <option value="">Keiner</option>
                            <option v-for="provider in paymentProviders" :value="provider.id">
                                {{ provider.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="d-flex align-items-center justify-content-center h-100">
                        <div class="checkbox-inline">
                            <label class="checkbox">
                                <input type="checkbox" v-model="formData.can_own_agencies">
                                <span></span> Darf Sub-Agenturen besitzen
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-5">
                <button class="btn btn-primary" @click="create">
                    <i class="fas fa-plus-square mr-1" />
                    {{ __('agency.create') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import BackButton from "@components/BackButton.vue";

export default {
    components: {BackButton},

    props: {
        paymentProviders: Array
    },

    data() {
        return {
            formData: {
                payment_provider_id: '',
                agency_name: '',
                can_own_agencies: false
            }
        }
    },

    methods: {
        create(){
            this.$inertia.post(this.$route('agency.create'), this.formData);
        }
    }
}
</script>
